import FourOhFours from "../utils/redirect/NotFound.json";
import { navigateTo } from "nuxt/app";

export default defineNuxtRouteMiddleware((to, from) => {

	const ignoreFileExtensions = [".webp", ".ico", ".jpg", ".png", ".webmanifest", ".txt", ".json", ".js", ".css", ".map", ".woff", ".woff2", ".ttf", ".eot", ".svg"];

	// Redirect URLs with dots in the slug to hyphen versions (301 redirect)
	// Example: /news/example.stock → /news/example-stock
	const hasFileExtension = ignoreFileExtensions.some(ext => to.path.endsWith(ext));
	if (!hasFileExtension && to.path.includes('.')) {
		// Replace all dots in the path with hyphens
		const newPath = to.path.replace(/\./g, '-');
		// Only redirect if the path actually changed
		if (newPath !== to.path) {
			const redirectUrl = newPath + (to.query && Object.keys(to.query).length > 0 ? '?' + new URLSearchParams(to.query).toString() : '');
			return navigateTo(redirectUrl, { redirectCode: 301 });
		}
	}

	const pageTypes = [
		"blog-slug",
		"blog-author-tim-sykes",
		"blog-page-page",
		"category-slug",
		"category-slug-page-page",
		"widgetpage"
	];

	if (pageTypes.includes(to.name)) {
		if (to.name === "category-slug") {
			const parsed_category = [
				"breaking-news",
				"case-studies",
				"charity-work",
				"guides",
				"infographics",
				"lessons-from-students",
				"mentor-update",
				"patterns-to-short",
				"patterns-to-watch",
				"stock-basics",
				"news",
				"watchlists",
				"penny-stocks",
				"press",
				"promoters",
				"penny-stock-scandals",
				"short-selling",
				"success-stories",
				"testimonials",
				"timalerts",
				"trading-lessons",
				"trading-psychology",
				"trading-recap",
				"trading-tips",
				"videos",
				"text-watchlists",
				""
			];

			if (
				to.name === "category-slug" &&
				to.params.slug.length > 2 &&
				!parsed_category.includes(to.params.slug[2])
			)
				return navigateTo("/404/", { redirectCode: 404 });
			if (
				to.name === "category-slug" &&
				to.params.slug.length > 3 &&
				!parsed_category.includes(to.params.slug[3])
			)
				return navigateTo("/404/", { redirectCode: 404 });
		}
		if (to.name === "widgetpage" && to.params.widgetpage.length > 2)
			return navigateTo("/404/", { redirectCode: 404 });
	}
	if (FourOhFours.includes(to.fullPath) && process.server) {
		return navigateTo("/404/", { redirectCode: 404 });
	}

	if (to.name === "blog-slug" && to.params.slug.length > 2) {
		return navigateTo("/404/", { redirectCode: 404 });
	}

	// Explicitly handle robots.txt to prevent trailing slash redirect
	if (to.path === "/robots.txt") {
		return;
	}

	// Check if path ends with any ignored file extension
	const hasIgnoredExtension = ignoreFileExtensions.some(ext => to.path.endsWith(ext));
	if (!to.path.endsWith("/") && !hasIgnoredExtension) {
		return navigateTo(to.path + "/", { redirectCode: 301 });
	}
});
